'use client'

import dynamic from 'next/dynamic'

const Agentation = dynamic(
  () => import('agentation').then((mod) => mod.Agentation),
  { ssr: false },
)

export function AgentationToolbar(): React.JSX.Element | null {
  if (process.env.NEXT_PUBLIC_AGENTATION !== 'true') {
    return null
  }

  return <Agentation />
}
